import styled, { css } from 'styled-components';
import { Icon } from 'src/components';
import { rtlFlip } from 'src/utils/theme';

interface SeoCopyProps {
  $isVisible: boolean;
}

export const FAQItemContainer = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.sz.s5};
    border-bottom: ${theme.bo.thinWidth} solid ${theme.co.secondary60};
  `,
);

export const TitleWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: ${theme.sz.s5};
  `,
);

export const ArrowIcon = styled(Icon)<SeoCopyProps>(
  ({ theme, $isVisible }) => css`
    display: inline-block;
    width: ${theme.sz.s6};
    height: ${theme.sz.s6};
    transform: rotate(calc(-90deg * ${rtlFlip(theme)}));

    ${
      $isVisible &&
      css`
        transform: rotate(0deg);
      `
    };

    svg {
      height: 100%;
      width: 100%;
    }

    @media (min-width: ${theme.sz.md}) {
      width: ${theme.sz.s8};
      height: ${theme.sz.s8};
    }
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    width: 100%;
    padding-left: ${theme.sz.s3};
    color: ${theme.co.secondary0};
    ${theme.typography.heading.mobile.xs};

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.xs};
    }
  `,
);

export const Description = styled.div<SeoCopyProps>(
  ({ theme, $isVisible }) => css`
    display: ${$isVisible ? 'block' : 'none'};
    padding-bottom: ${theme.sz.s5};
    margin-left: ${theme.sz.s6};
    padding-left: ${theme.sz.s3};
    color: ${theme.co.secondary0};
    ${theme.typography.paragraph.base};

    @media (min-width: ${theme.sz.md}) {
      margin-left: ${theme.sz.s8};
    }
  `,
);
